<template>
  <div id="app" align="center">
    <div v-if="hasCompleted" class="container">
      <p class="header">
        คุณเคยทำแบบสอบถามนี้แล้ว หรือผิดเกิน 3 ครั้ง 😢<br />ไม่สามารถทำซ้ำได้
        (คำถามนี้สร้างมาเพื่อใครบางคน)<br />ขอบคุณที่เข้ามาเล่นนะ
      </p>
    </div>

  

    <div v-else class="container">
      <div v-if="!showResult">
        <p class="header">{{ currentQuestion.question }}</p>
        <p v-if="wrongAttempts" class="attempts">
          ❌ คุณผิดได้อีกแค่ {{ 3 - wrongAttempts }} ครั้ง
        </p>
        <div v-for="(choice, idx) in shuffledChoices" :key="idx">
          <button class="btn primary" @click="handleAnswer(choice.correct)">
            {{ choice.text }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="showResult" class="container">
      <p class="header">
        🎉 เฉลย 🎉<br />
        คำถามนี้สร้างมาเพื่อ <br />แม่ของกะเพรา น้าของคูเปอร์<br />
        ที่ชอบไถ tiktok ทั้งวัน 🐱📱<br /><br />
        ไม่มีอะไรมาก แค่อยากสร้างคำถามเล่นๆ เฉยๆ 😄<br />
        ถ้าเข้ามาถึงตรงนี้ได้ เก่งนะนี่! 🌟
      </p>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  name: "QuizApp",
  data() {
    return {
      currentIndex: 0,
      hasCompleted: false,
      showResult: false,
      wrongAttempts: 0,
      questions: [
        {
          question: "1. คุณอยากลองทำแบบทดสอบหรือไม่",
          choices: [
            { text: "ทำ", correct: true },
            { text: "ไม่ทำ", correct: false },
          ],
        },
        {
          question: "2. คุณเป็นผู้หญิงหรือไม่",
          choices: [
            { text: "ใช่", correct: true },
            { text: "ไม่ใช่", correct: false },
          ],
        },
        {
          question: "3. คุณเรียนที่ใด",
          choices: [
            { text: "มหาวิทยาลัยมหาสารคาม", correct: true },
            { text: "มหาวิทยาลัยราชภัฏสวนสุนันทา", correct: false },
            { text: "มหาวิทยาลัยราชภัฏมหาสารคาม", correct: false },
          ],
        },
        {
          question: "4. คุณเรียนคณะอะไร",
          choices: [
            { text: "คณะแพทย์ศาสตร์", correct: true },
            { text: "คณะมนุษยศาสตร์", correct: false },
            { text: "คณะศึกษาศาสตร์", correct: false },
          ],
        },
        {
          question: "5. คุณอาศัยอยู่ภาคใด",
          choices: [
            { text: "ภาคอีสาน", correct: true },
            { text: "ภาคกลาง", correct: false },
            { text: "ภาคใต้", correct: false },
          ],
        },
        {
          question: "6. คุณมีสัตว์เลี้ยงหรือไม่",
          choices: [
            { text: "มี", correct: true },
            { text: "ไม่มี", correct: false },
          ],
        },
        {
          question: "7. สัตว์เลี้ยงของคุณคืออะไร",
          choices: [
            { text: "สนัข", correct: false },
            { text: "แมว", correct: true },
            { text: "กระต่าย", correct: false },
          ],
        },
        {
          question: "8. แมวของคุณพันธุ์อะไร",
          choices: [
            { text: "เปอร์เซีย", correct: false },
            { text: "สก๊อตติสโฟล์ด", correct: true },
            { text: "วิเชียรมาศ", correct: false },
          ],
        },
        {
          question: "9. แมวของคุณมีชื่อเกี่ยวกับอะไร",
          choices: [
            { text: "ผัก", correct: true },
            { text: "ผลไม้", correct: false },
          ],
        },
        {
          question: "10. คุณมีหลานหรือไม่",
          choices: [
            { text: "มี", correct: true },
            { text: "ไม่มี", correct: false },
          ],
        },
        {
          question: "11. หลานของคุณเป็นเพศอะไร",
          choices: [
            { text: "ผู้ชาย", correct: true },
            { text: "ผู้หญิง", correct: false },
          ],
        },
        {
          question: "12. คุณเคยดูละครคุณธรรมจีนหรือไม่",
          choices: [
            { text: "เคยดู", correct: true },
            { text: "ไม่เคยดู", correct: false },
          ],
        },
        {
          question: "13. ละครคุณธรรมจีนที่คุณดูคือเรื่องอะไร",
          choices: [
            { text: "หลับเพื่อจบ ลืมเพื่อเริ่ม", correct: true },
            { text: "ความรักที่ว่างเปล่า", correct: false },
            { text: "วิวาห์ฟ้าแลบ", correct: false },
          ],
        },
        {
          question: "14. สิ่งที่คุณทำได้ทั้งวันคืออะไร",
          choices: [
            { text: "ดู tiktok", correct: true },
            { text: "ดู youtube", correct: false },
            { text: "ดู netflix", correct: false },
          ],
        },
        {
          question: "15. ตอนเด็กๆแม่คุณชอบเอาคุณไปปล่อยไว้่ที่ไหน",
          choices: [
            { text: "วัด", correct: true },
            { text: "บ้านญาต", correct: false },
            { text: "อยู่ตามลำพัง", correct: false },
          ],
        },
        {
          question: "16. เวลาตื่นคุณจะพิมพ์ว่าอะไร",
          choices: [
            { text: "ตื่นแน๊ะ", correct: true },
            { text: "มอร์นิ่ง", correct: false },
            { text: "ตื่นละ", correct: false },
          ],
        },
        {
          question: "17. ถ้าเล่นมาถึงนี้คุณคงงง ว่าคำถามทำไมเกี่ยวกับฉันใช่ไหม",
          choices: [
            { text: "ใช่", correct: true },
            { text: "ใช่", correct: true },
          ],
        },
      ],
    };
  },
  computed: {
    currentQuestion() {
      return this.questions[this.currentIndex];
    },
    shuffledChoices() {
      return this.shuffleArray([...this.currentQuestion.choices]);
    },
  },
  created() {
    const done = localStorage.getItem("quiz_completed");
    if (done === "true") {
      this.hasCompleted = true;
    }
  },
  methods: {
    handleAnswer(isCorrect) {
      if (!isCorrect) {
        this.wrongAttempts++;
        if (this.wrongAttempts >= 3) {
          localStorage.setItem("quiz_completed", "true");
          this.hasCompleted = true;
          this.sendAnswersToGoogle();
        }
        return;
      }

      if (this.currentIndex < this.questions.length - 1) {
        this.currentIndex++;
      } else {
        this.showResult = true;
        this.sendAnswersToGoogle();
        localStorage.setItem("quiz_completed", "true");
      }
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    detectDevTools() {
  const devtools = {
    open: false,
    orientation: null
  };

  const threshold = 160;
  const emitEvent = (status) => {
    if (status) {
      this.hasCompleted = true;
      alert("พบปัญหา: กรุณาปิด Developer Tools เพื่อดำเนินการต่อ");
      localStorage.setItem("quiz_completed", "true");
    }
  };

  const check = () => {
    const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    const heightThreshold = window.outerHeight - window.innerHeight > threshold;
    const orientation = widthThreshold ? 'vertical' : 'horizontal';

    if (
      !(heightThreshold || widthThreshold)
    ) {
      devtools.open = false;
      return;
    }

    if (
      !devtools.open ||
      devtools.orientation !== orientation
    ) {
      devtools.open = true;
      devtools.orientation = orientation;
      emitEvent(true);
    }
  };

  // Trick with toString on console.log
  const element = new Image();
  Object.defineProperty(element, 'id', {
    get: function () {
      emitEvent(true);
      return 'devtools-detected';
    }
  });
  console.log('%c', element);

  setInterval(check, 1000);
},
sendAnswersToGoogle() {
      const payload = {
        answers: this.userAnswers, 
        correct: this.correctCount, 
        wrong: this.wrongCount     
      };

      console.log('Sending to Google Sheet:', payload);

      axios.post('https://script.google.com/macros/s/AKfycbzUUw2ic4VDByoGA3vlAwHlAPCqQ4x_04mMOLdpBY-LHe9ZhA1stzMHdloE_2p3OEqyQg/exec', payload)
        .then(response => {
          console.log('Google Sheet response:', response.data);
        })
        .catch(error => {
          console.error('Error sending to Google Sheet:', error);
        });
    },
  },
  mounted() {
    if (localStorage.getItem("quiz_completed") === "true") {
    this.hasCompleted = true;
  }
  this.detectDevTools();
  },
};
</script>

<style>
body {
  background-color: #fff8f0;
  font-family: "Kanit", sans-serif;
}
.container {
  max-width: 600px;
  margin: 40px auto;
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.header {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
.attempts {
  margin-bottom: 10px;
  color: #c00;
}
.btn {
  display: block;
  margin: 10px auto;
  padding: 12px 24px;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  background: #f9a825;
  color: #fff;
  cursor: pointer;
}
.btn:hover {
  background: #f57f17;
}
</style>
